import React from 'react';
import { CSSTransition } from 'react-transition-group';
import { ErrorMessage, Formik } from 'formik';

import BasicButtonGroup from 'components/BasicButtonGroup';
import BasicButton from 'components/BasicButton';
import BasicInputFile from 'components/BasicInputFile';

import CoverLetterFormValidationSchema from 'scenes/Form/components/CoverLetterForm/validate';
import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation';

const CoverLetterForm = props => {
  const {
    actions: { proceed, cancel },
  } = props;

  const handleSubmit = values => {
    proceed(values.Letter);
  };

  const removeLetter = (field, setFieldValue) => {
    setFieldValue(field, null);
  };

  const selectLetter = (e, setFieldValue, setFieldTouched) => {
    const {
      target: { files, name },
    } = e;
    const [file = null] = files;

    if (file) {
      setFieldValue(name, file);
      setFieldTouched(name, true, true);
    }
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div>
        <Formik
          initialValues={{ Letter: null }}
          validationSchema={CoverLetterFormValidationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
          }) => (
            <form
              onSubmit={handleSubmit}
              className="form__content"
              style={{ maxWidth: '100%' }}
            >
              <div className="dialog__message" style={{ marginBottom: '5px' }}>
                You need to add a cover letter to apply for this position
              </div>

              <BasicInputFile
                inputStyles={{ marginLeft: 0 }}
                file={values.Letter}
                fieldName="Letter"
                onRemoveHandler={field => removeLetter(field, setFieldValue)}
                onChangeHandler={e =>
                  selectLetter(e, setFieldValue, setFieldTouched)
                }
                accept=".doc,.docx,.pdf,.odt,.rtf"
                disclaimer="(*doc, *docx, *pdf, *odt, *rtf)"
              />
              <ErrorMessage
                name="Letter"
                render={message => <div className="form__error">{message}</div>}
              />

              <div className="form__controls form__controls--compact">
                <BasicButtonGroup
                  groupStyles={{
                    justifyContent: 'center',
                    width: '100%',
                  }}
                >
                  <BasicButton
                    disabled={!values.Letter || !!errors.Letter}
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnText="Add Cover Letter"
                  />
                  <BasicButton
                    controlFunc={cancel}
                    btnWidth={200}
                    btnHeight={35}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default CoverLetterForm;
